import React from 'react';


const SwitchField = props => {

  return <div /* style={{ marginBottom: '5vh' }} */></div>;
};

export default SwitchField;
